/**
 * Airship analytics.
 */
export class AirshipAnalytics {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Associates an identifier.
     *
     * @param key The key.
     * @param identifier The identifier. `null` to remove.
     * @returns A promise.
     */
    associateIdentifier(key, identifier) {
        return this.plugin.perform('analytics#associateIdentifier', [
            key,
            identifier,
        ]);
    }
    /**
     * Tracks a screen.
     * @param screen The screen. `null` to stop tracking.
     * @returns A promise.
     */
    trackScreen(screen) {
        return this.plugin.perform('analytics#trackScreen', screen);
    }
    /**
     * Adds a custom event.
     * @param event The custom event.
     * @return A promise that returns null if resolved, or an Error if the
     * custom event is rejected.
     */
    addCustomEvent(event) {
        return this.plugin.perform('analytics#addCustomEvent', event);
    }
    /**
     * Gets the Airship session ID. The session ID is a UUID that updates on foreground and background.
     * @returns A promise.
     */
    getSessionId() {
        return this.plugin.perform('analytics#getSessionId');
    }
}
//# sourceMappingURL=AirshipAnalytics.js.map